<template>
<div>
	<div class="form section-a dealer-form">
		<div class="section-subhead">
            <i v-if="locked" class="fa fa-lock" style="padding: 0 0.25em 0 0; cursor: pointer;" @click="showLockedReason()"></i>
			Section A - Firearms List
		</div>

		<div class="section-a-detail">
			<div v-if="form.form_data.section_a.firearms_list && form.form_data.section_a.firearms_list.length > 0" class="section-a-list">
				<div v-for="(firearm, index) in form.form_data.section_a.firearms_list" :key="'firearm_' + index" class="section_a_firearm three-columns" :class="'line_' + (index + 1)">
					<div class="firearm-line-number">{{ index + 1 }}</div>
					<div>
						<label>Manufacturer and Importer (or PMF)</label>
						<input type="text" v-model="firearm.manufacturer" />
					</div>
					<div>
						<label>Type</label>
						<input type="text" v-model="firearm.gun_type" />
					</div>
					<div>
						<label>Serial Number</label>
						<input type="text" v-model="firearm.serial_number" />
					</div>
					<div>
						<label>Model</label>
						<input type="text" v-model="firearm.model" />
					</div>
					<div>
						<label>Caliber</label>
						<input type="text" v-model="firearm.caliber" />
					</div>
					<div class="right">
						<div class="button neutral small" style="margin: 1.8em 0 0 0;" @click="removeLine(index)">Remove</div>
					</div>
				</div>
			</div>

			<div class="right-column-section">
				<p>
					<label>Total Number of Firearms to be Transferred</label>
					<input type="text" v-model="form.form_data.section_a.total_firearms_transferred" readonly />
				</p>
				<p :class=" { 'no-margin': form.form_data.section_a.transaction_pawn_redemption }" ref="transaction_pawn_redemption">
					Is any part of this transaction a pawn redemption?<br>
					<binary-toggle v-model="form.form_data.section_a.transaction_pawn_redemption" values="Y,N" />
				</p>
				<p v-show="form.form_data.section_a.transaction_pawn_redemption == 'Y'" ref="transaction_pawn_redemption_line_numbers">
					<label>Which Line Number(s)?</label>
					<input type="text" v-model="form.form_data.section_a.transaction_pawn_redemption_line_numbers"/>
				</p>
				<p ref="private_party_transfer">
					Is any part of this transaction to facilitate a private party transfer?<br>
					<binary-toggle v-model="form.form_data.section_a.private_party_transfer" />
				</p>
			</div>

			<div class="two-columns" style="margin: 1em 0 0 0; align-items: start;">
				<div>
					<label>Search for a serial number to add to Section A...</label>
					<div class="input-with-control">
						<input type="search" v-model="searchTerm" placeholder="Serial number..." @search="serialNumberSearch()" v-focus>
						<div class="button action input-go" @click="serialNumberSearch()"><i class="fas fa-search"></i></div>
					</div>
					<div style="margin: 0.5em 0 0 0;">
						<div :class="['button', lastFirearmIsBlank ? 'disabled' : 'action', 'small']" @click="addNewLine()"><i class="fa fa-plus" /></div> 
						<label style="display: inline-block; margin: 0 0 0 0.5em;">Or add an empty set of inputs and enter info manually</label>
					</div>
				</div>
				<div style="margin: 2em 0 0 0;">
					{{ searchMessage }}
				</div>
			</div>
		</div>
	</div>

	<div v-if="searchResults.length > 1" class="modal medium-modal">
		<div class="inner">
			<h2>Multiple Serial Numbers Found</h2>
			<div class="content search-list">
				<div v-for="(item, index) in searchResults" class="clickable-list-item" style="display: grid; grid-template-columns: 1fr 1fr 1fr 1fr 1fr; grid-column-gap: 1em;" @click="assignFirearmToList(item)">
					<div>{{ item.manufacturer }}</div>
					<div>{{ item.gun_type }}</div>
					<div>{{ item.model }}</div>
					<div>{{ item.caliber }}</div>
					<div>{{ item.serial_number }}</div>
				</div>
			</div>
			<div class="controls">
				<div class="button cancel" @click="searchResults = []">Cancel</div>
			</div>
		</div>
	</div>

	<div v-if="locked" style="position: absolute; top: 2.5em; left: 0; width: 100%; height: 100%; cursor: not-allowed;" @click="showLockedReason()"></div>

	<message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

</div>
</template>

<script>
import BinaryToggle from '@/components/BinaryToggle.vue'
export default {
	name: 'form4473-section-a',
	props: ['form', 'locked'],
    components: {
        'binary-toggle': BinaryToggle,
	},
	data() {
		return {
			loading: false,
			saving: false,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			searchTerm: '',
			searchMessage: '',
			searchResults: [],
			testValue: ''
		}
	},
	created() {
	},
	computed: {
		lastFirearmIsBlank() {
			let isBlank = true
			if (this.form.form_data.section_a.firearms_list.length > 0) {
				for (const [key, value] of Object.entries(this.form.form_data.section_a.firearms_list[this.form.form_data.section_a.firearms_list.length - 1])) {
					if (value) {
						isBlank = false
					}
				}
			} else {
				isBlank = false
			}
			return isBlank
		}
	},
	methods: {
		serialNumberSearch() {
			if (this.loading || !this.searchTerm) { return }
			let excludeFromSearch = []
			for (var i = 0; i < this.form.form_data.section_a.firearms_list.length; i++) {
				if (this.form.form_data.section_a.firearms_list[i].serial_number != this.sectionSearchTerm) {
					excludeFromSearch.push(this.form.form_data.section_a.firearms_list[i].ffl_log_book_entry_id)
				}
			}
			this.apiCall({ destination: 'serial_number_lookup', data: { on_hand: 1, search_term: this.searchTerm, exclude: excludeFromSearch }}).then(obj => {
				if (obj.status == 'error' || obj.firearms_list.length == 0) {
					this.searchMessage = 'Serial number not found.'
				} else if (obj.firearms_list.length > 1) {
					this.searchResults = obj.firearms_list
				} else if (obj.firearms_list.length == 1) {
					this.assignFirearmToList(obj.firearms_list[0])
					this.searchTerm = ''
				}
			}).catch(err => {
				console.log(err)
			})
		},
		assignFirearmToList(firearm) {
			this.form.form_data.section_a.firearms_list.push({ 
				ffl_log_book_entry_id: firearm.ffl_log_book_entry_id, 
				caliber: firearm.caliber, 
				gun_type: firearm.gun_type, 
				manufacturer: firearm.manufacturer, 
				model: firearm.model, 
				serial_number: firearm.serial_number 
			})
			this.form.form_data.section_a.total_firearms_transferred = this.$toWords(this.form.form_data.section_a.firearms_list.length)
			this.searchResults = []
			this.searchTerm = ''
		},
		addNewLine() {
			this.searchMessage = ''
			// is the last line already blank?
			if (this.lastFirearmIsBlank) { return }
			this.form.form_data.section_a.firearms_list.push({ ffl_log_book_entry_id: "", caliber: "", gun_type: "", manufacturer: "", model: "", serial_number: "" })
			this.form.form_data.section_a.total_firearms_transferred = this.$toWords(this.form.form_data.section_a.firearms_list.length)
		},
		removeLine(index) {
			this.searchMessage = ''
			this.form.form_data.section_a.firearms_list.splice(index, 1)
			this.form.form_data.section_a.total_firearms_transferred = this.$toWords(this.form.form_data.section_a.firearms_list.length)
		},
		validateSection() {
			for (const [key, element] of Object.entries(this.$refs)) {
				this.removeError(element)
			}
			let data = this.form.form_data.section_a
			let errorMessage = ''
			data.firearms_list.forEach((firearm, index) => {
				if (Object.values(firearm).every(x => x === null || x === '')) {
					this.removeLine(index)
				} else {
					for (const [key, value] of Object.entries(firearm)) {
						if (key != 'ffl_log_book_entry_id' && (value === null || value === '')) {
							errorMessage = 'Missing value for ' + key.replace('_', ' ')
							return
						}
					}
				}
			})
			if (data.firearms_list.length == 0) {
				errorMessage = 'Enter at least one firearm.'
			}
			if (!errorMessage && !data.transaction_pawn_redemption) {
				this.applyError(this.$refs['transaction_pawn_redemption'])
				errorMessage = this.$refs['transaction_pawn_redemption'].textContent
			}
			if (!errorMessage && !data.private_party_transfer) {
				this.applyError(this.$refs['private_party_transfer'])
				errorMessage = this.$refs['private_party_transfer'].textContent
			}
			if (!errorMessage && data.transaction_pawn_redemption == 'Y' && !data.transaction_pawn_redemption_line_numbers) {
				this.applyError(this.$refs['transaction_pawn_redemption_line_numbers'])
				errorMessage = this.$refs['transaction_pawn_redemption_line_numbers'].textContent
			}
			return errorMessage
		},
		applyError(element) {
			element.classList.add("please-correct")
			element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
		},
		removeError(element) {
			element.classList.remove("please-correct")
		},
		showLockedReason() {
			this.message = 'Section A is locked because<br>'
			if (this.form.internal_use_only == 2) {
				this.message += 'this form is awaiting correction by the customer.'
			} else if (this.form.moved_to_ffl_log_book_form_id) {
				this.message += 'it is a previous version of a corrected form.'
			} else {
				this.message += 'Section E has been signed.'
			}
			this.messageStatus = 'alert'
		}
	}
}
</script>
